import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Column,
  DataGrid,
  Selection,
  Button,
} from "devextreme-react/data-grid";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button1 from "@material-ui/core/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import swal from "sweetalert";
import { saveAs } from "file-saver-es";
import axios from "axios";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import { api_path } from "../../shared.js";
import ReactHtmlParser from "react-html-parser";
const url_openjob = api_path + "/GET_OPEN_JOB.php";
export function OpenJobManagementDatagrid(props) {
  const [searchParams] = useSearchParams();
  const DOCNO = searchParams.get("doc");
  const shipper = searchParams.get("shpr");
  const cnee = searchParams.get("cnee");
  const [GET_ORDER_ID, SET_ORDER_ID] = useState("");
  const [GET_USER_ID, SET_USER_ID] = useState("");
  const [GET_ADD_EMAIL, SET_ADD_EMAIL] = useState("");
  const [GET_SUBJECT_MAIL, SET_SUBJECT_MAIL] = useState("");
  const [GET_TO_MAIL, SET_TO_MAIL] = useState("");
  const [GET_CC_MAIL, SET_CC_MAIL] = useState("");
  const [GET_BODY_MAIL, SET_BODY_MAIL] = useState("");
  const [GET_CUSTOMER_CODE, SET_CUSTOMER_CODE] = useState("");
  const [GET_ORDER_NO, SET_ORDER_NO] = useState("");
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState("");
  const [GET_BSE_NO, SET_BSE_NO] = useState("");
  const [GET_SALES_EMAIL, SET_SALES_EMAIL] = useState("");
  const [GET_SALES_ID, SET_SALES_ID] = useState("");
  const [GET_JOB_NO, SET_JOB_NO] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [GET_CUSTOMER_TYPE, SET_CUSTOMER_TYPE] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  
 
   
  useEffect(() => {
    SET_CUSTOMER_CODE(shipper);
    //let JOB_NO='SSE25010007';
    let mailHtm_detail ="";
  
    fetch(api_path + "/GET_OPEN_JOB.php?JOB_NO=" + GET_JOB_NO)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          if (i.JOBNO=="NO DATA") {
            setButtonDisabled(false)
            SET_TO_MAIL("")
            SET_CC_MAIL("")
            SET_SUBJECT_MAIL("")
            SET_BODY_MAIL("")
          }else{
       
          setButtonDisabled(true)
          SET_ORDER_ID(i.ORDER_ID)
          mailHtm_detail += "<!DOCTYPE html><html><head>";
          mailHtm_detail += "<style>";
          mailHtm_detail += "table, th, td {padding:2px;margin:0px;border:1px solid #EBEBEB; border-collapse: collapse;text-align:left;font-size:12px;}";
          mailHtm_detail += " td{margin:4px;} .p {font-size:12px!important;}";
          mailHtm_detail += " .bold {font-weight:bold;}";
          mailHtm_detail += "</style>";
          mailHtm_detail += "</head><body>";
          mailHtm_detail += "<p>Please open job as following details.</p>";
        
       
          mailHtm_detail += "<p>JOB No. : "+i.DOCNO+" / "+i.JOBNO+"</p>";
          mailHtm_detail += "<p>BOOKING NO. : "+i.BOOKINGNO+"</p>";
          mailHtm_detail += "<p>S/I CUT OFF :  </p>";
          mailHtm_detail += "<p>Contract :  </p>";
          mailHtm_detail += "<p>SHIPPER : "+i.SHIPPERNAME+"</p>";
          mailHtm_detail += "<p>Sales : Khun "+i.SALES_NAME+" @"+i.SALES_EMAIL+"</p>";
          mailHtm_detail += "<p>Quotation no : "+i.QUOTATION_NO+"</p><br/>";

          mailHtm_detail += "<table width='80%'>";
          mailHtm_detail += "<colgroup>";
          mailHtm_detail += "<col span='1' style='width: 20%;'>";
          mailHtm_detail += "<col span='1' style='width: 80%;'>";
          mailHtm_detail += "</colgroup><tbody>";
          
          mailHtm_detail += "<tr><td class='bold'>Order No: </td><td>" +i.ORDER_NO+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Quotation No: </td><td>" +i.QUOTATION_NO+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Customer Ref: </td><td>"+i.CUSTOMER_REF+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Customer: </td><td>"+i.SHIPPERNAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>CNEE: </td><td>"+i.CONSIGNEENAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Agent: </td><td>"+i.AGENTNAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Actual Shipper: </td><td>"+i.SHIPPERLOADNAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>3rd Party: </td><td>"+i.PARTY_3RD_NAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Coload Shipment: </td><td>"+i.COLOAD_NAME+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Credit Term: </td><td>"+i.CREDIT_TERM+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Job Owner: </td><td>"+i.JOBOWNER+"</td></tr>";
  
          mailHtm_detail += "<tr><td class='bold'>Place Of Receipt: </td><td>"+i.POR+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Port Of Loading: </td><td>"+i.POL+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Port Of Discharge: </td><td>" +i.POD+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Place Of Delivery: </td><td>"+i.DEL+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Final Destination: </td><td>"+i.FINAL+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Inland Postcode: </td><td>"+i.FINAL_ADDRESS+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Commodity: </td><td>"+i.COMMODITY+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>HS Code: </td><td>"+i.HSCODE+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Cargo Type: </td><td>"+i.CARGO_TYPE+"</td></tr>";
         
          mailHtm_detail += "<tr><td colspan='2' style='text-align: left;'>";
          mailHtm_detail += "<table width='100%'><thead><tr style='font-weight:bold;background-color:#EBEBEB;'>";
          // if($row['LOADTYPE']=="LCL"){
          //     mailHtm_detail += "<th>CARRIER</th><th>FREIGHT FORWARDER</th>";
          //     mailHtm_detail += "</tr></thead>";
          // }else{
              mailHtm_detail += "<th>CARRIER</th><th>S/C</th><th>BULLET CODE</th><th>NOTE</th>";
              mailHtm_detail += "<th>BOOK REF</th><th>BOOK NO</th><th>PROFORMA ETD</th><th>SMF REFNO</th><th>CUTOFF</th><th>ETA</th><th>REMARK</th>";
              mailHtm_detail += "</tr></thead>";
          // }
        
          //     if($row['LOADTYPE']=="LCL"){
                  // mailHtm_detail += "<tr>";
                  // mailHtm_detail += "<td width='100'>" . $row2['CARRIER_CODE'] . "</td>";
                  // mailHtm_detail += "<td width='100'>" . $row2['SERVICES_CONTRACT'] . "</td>";
                  // mailHtm_detail += "</tr>";
          //     }else{
      
                  mailHtm_detail += "<tr>";
                  mailHtm_detail += "<td width='100'>"+i.CARRIER_CODE+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.SERVICES_CONTRACT+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.BULLET_CODE+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.SCAC+ "</td>";
                  mailHtm_detail += "<td width='100'>" +i.BOOKINGREF+ "</td>";
                  mailHtm_detail += "<td width='100'>" +i.BOOKINGNO+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.PROFORMA_ETD+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.SMF_REFNO+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.CONTAINER_CUTOFF_TIME+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.ETA+"</td>";
                  mailHtm_detail += "<td width='100'>" +i.REMARK+ "</td>";
                  // if($row2['ACTIVE_STATUS']=="1"){
                  //     mailHtm_detail += "<td width='100' class='green'>ACTIVE</td>";
                  // }else if($row2['ACTIVE_STATUS']=="0"){
                  //     mailHtm_detail += "<td width='100' class='red'>INACTIVE</td>";
                  // }else if($row2['ACTIVE_STATUS']=="100"){
                  //     mailHtm_detail += "<td width='100' class='green'>" . $row2['STATUS_NAME'] . "</td>";
                  // }else{
                  //     mailHtm_detail += "<td width='100' class='red'>" . $row2['STATUS_NAME'] . "</td>";
                  // }
                 
          //     }
          mailHtm_detail += "</tr></table>";
          mailHtm_detail += "</td></tr>";
          mailHtm_detail += "<tr><td colspan='2' style='text-align: left;'>";
          mailHtm_detail += "<table width='100%'><thead><tr style='font-weight:bold;background-color:#EBEBEB;'>";
         if(i.LOADTYPE=="LCL"){
              mailHtm_detail += "<th>NUMBER OF PACKAGES</th>";
              mailHtm_detail += "<th>PACKAGE UNIT</th>";
              mailHtm_detail += "<th>CBM</th>";
              mailHtm_detail += "<th>GW</th>";
              mailHtm_detail += "<th>DIMENSIONS NOTE</th>";
              mailHtm_detail += "</thead>";
              mailHtm_detail += "<tr>";
              mailHtm_detail += "<td width='100'>" +i.NO_OF_PACK+"</td>";
              mailHtm_detail += "<td width='100'>" +i.PACKAGE_UNIT+"</td>";
              mailHtm_detail += "<td width='100'>" +i.CBM+ "</td>";
              mailHtm_detail += "<td width='100'>" +i.GW+ "</td>";
              mailHtm_detail += "<td>" +i.DIMENSION_NOTE+ "</td>";
              mailHtm_detail += "</tr>";
              mailHtm_detail += "</table></td></tr>";
         }else{
              mailHtm_detail += "<th>20'</th>";
              mailHtm_detail += "<th>TYPE 20'</th>";
              mailHtm_detail += "<th>40'</th>";
              mailHtm_detail += "<th>TYPE 40'</th>";
              mailHtm_detail += "<th>40 HQ'</th>";
              mailHtm_detail += "<th>TYPE 40HQ'</th>";
              mailHtm_detail += "<th>45'</th>";
              mailHtm_detail += "<th>TYPE 45'</th>";
              mailHtm_detail += "<th>GW</th>";
              mailHtm_detail += "</thead>";
              mailHtm_detail += "<tr>";
              mailHtm_detail += "<td width='100'>" +i.CNT20+ "</td>";
              mailHtm_detail += "<td width='100'>" +i.TYPE20+ "</td>";
              mailHtm_detail += "<td width='100'>"+i.CNT40+"</td>";
              mailHtm_detail += "<td width='100'>"  +i.TYPE40+ "</td>";
              mailHtm_detail += "<td width='100'>"+i.CNT40HQ+"</td>";
              mailHtm_detail += "<td width='100'>" +i.TYPE40HQ+"</td>";
              mailHtm_detail += "<td width='100'>" +i.CNT45+"</td>";
              mailHtm_detail += "<td width='100'>" +i.TYPE45+"</td>";
              mailHtm_detail += "<td width='100'>" +i.GW+"</td>";
              mailHtm_detail += "</tr>";
              mailHtm_detail += "</table></td></tr>";
          }
           
          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>SHIPMENT DETAILS</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Load Type: </td><td>"+i.LOADTYPE+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Incoterm: </td><td>"+i.INCOTERM+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>CY Term: </td><td>"+i.CYTERM+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Door BY: </td><td>"+i.DOOR_BY+"</td></tr>";
  
          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>DOCUMENT TYPE</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Master BL Term: </td><td>"+i.MBL_TERM+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Master BL Type: </td><td>"+i.MBL_TYPE+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>House BL Term: </td><td>"+i.HBL_TERM+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>House BL Type: </td><td>" +i.HBL_TYPE+"</td></tr>";
  
          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>ORIGIN SERVICES</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Shipping: </td><td>" +i.SHIPPING+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Trucking: </td><td>" +i.TRUCKING+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Insurance: </td><td>" +i.INSURANCE+ "</td></tr>";
  
          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>DELIVERY SERVICES</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Shipping: </td><td>"+i.SHIPPING_DEL+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Trucking: </td><td>"+i.TRUCKING_DEL+"</td></tr>";
  
          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>MANIFEST FILING</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>AMS/ACI Filing by: </td><td>"+i.AMS_SCAC+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>ISF Filing by: </td><td>" +i.ISF_BY+ "</td></tr>";

          mailHtm_detail += "<tr><td colspan='2' style='font-weight:bold;background-color:#EBEBEB;'>CONTACT</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Remark To CS: </td><td class='red'>" +i.REMARK_TO_CS+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Remark To DOC: </td><td>"+i.REMARK_TO_DOC+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Remark To ACC: </td><td>"+i.REMARK_TO_ACC+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Agent Sales Email: </td><td>" +i.AGENT_SALES_EMAIL+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Pre Alert Email: </td><td>" +i.PREALERT_EMAIL+"</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Booking PIC: </td><td>" +i.BOOKING_PIC+ "</td></tr>";
          mailHtm_detail += "<tr><td class='bold'>Doc PIC: </td><td>" +i.DOC_PIC+"</td></tr>";
          mailHtm_detail += "</tbody></table>";
     
          mailHtm_detail += "</body></html>";
  

          SET_CC_MAIL("docth@sinologistics.co.th,CSVCTH@sinologistics.co.th,mayuree.s@sinologistics.co.th,"+i.SALES_EMAIL)

          SET_BODY_MAIL(mailHtm_detail);
          SET_SUBJECT_MAIL(
            "OPEN JOB: " +
              i.DOCNO +
              " / " +
              i.JOBNO+
              " / BKG. " +
              i.BOOKNO +
              " / SHIPPER: " +
              i.SHIPPER_SMF +
              " / PORT: " +
              i.DEL_SMF +
              " / ETD: " +
              i.ETD_SMF +
              ""
          );
        } 
      }
      });

  }, [GET_JOB_NO]);
  function fetchData(docno) {
    fetch(api_path + "/SalesOrderGetDetailByDocno.php?DOCNO=" + docno)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          SET_SALES_ID(i.SALES_ID);
          SET_SALES_EMAIL(i.SALES_EMAIL);
          SET_ORDER_NO(i.ORDER_NO);
        }
      });
  }

  const dataSourceOpenJob = createStore({
    key: "JOBNO",
    loadUrl: `${url_openjob}`,
    loadParams: { JOB_NO: GET_JOB_NO },
  });

  
  /////////////////////////////////////////////////////


  const [errors, setErrors] = useState({});
  const validateForm3 = () => {
    const errors = {};
    if (!GET_JOB_NO) {
      errors.JOBNO = "Required";
    }
    // if (!GET_TO_MAIL) {
    //   errors.ToMail = "Required";
    // }
    if (!GET_SUBJECT_MAIL) {
      errors.SubjectMail = "Required";
    }
    return errors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateForm3();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      swal({
        title: "Are you sure?",
        text: "to send open job.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          var data = {
            ORDER_ID: GET_ORDER_ID,
            USERID: getCrmId,
            REMARK: "Open job",
          };
          fetch(api_path + "/SALES_ORDER_UpdateSalesOrderOpenJob.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result["status"] == "200") {
                makeOutlookFile(GET_BODY_MAIL,GET_TO_MAIL,GET_CC_MAIL,GET_SUBJECT_MAIL)
                swal("Done.", "", "success", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  const url =
                    api_path +
                    "/SENDMAIL_SALESORDER.php?order_id=" +
                    GET_ORDER_ID +
                    "&flag=openjob&order_status=11";
                  axios
                    .get(url)
                    .then((response) => {
                      // handle success
                      console.log(result["message"]);
                    })
                    .then((data) => {
                      console.log(data);
                      // Handle data
                    })
                    .catch((error) => {
                      // handle errors
                    });

                  ////////////////////////////////////////////////////
                  window.location = "./JobManagment";
                });
              } else {
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                });
              }
            });

          ////////////////////////////////
        }
      });
    }
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  const Mailto = ({ email, ccmail, subject, body, children }) => {
    return (
      <a
        href={`mailto:${email}?subject=${
          encodeURIComponent(subject) || ""
        }&body=${encodeURIComponent(body) || ""}`}
        className="btn MuiButton-containedPrimary"
      >
        <span className="MuiButton-label">{children}</span>
      </a>
    );
  };

    function makeOutlookFile(bodyMail,emailto,emailCc,emailsubject) {
    // var mailHtm ="<h1> Sample Email <h1>";
    // var emailto = "abc@Wperficient.com";
    // var emailsubject = "Javascript Gmail";
    var emlCont = 'To: '+emailto + '\n';
    emlCont += 'CC: '+emailCc+'\n';
    emlCont += 'Subject: '+emailsubject+'\n';
    emlCont += 'X-Unsent: 1'+'\n';

    emlCont += 'Content-Type: text/html; charset=UTF-8'+'\n';
    emlCont += ''+'\n';
    emlCont +=  bodyMail ;

    console.log(emlCont) ;
    var textFile = null;
    var data = new Blob([emlCont], {type: 'text/plain'});
    if (textFile !== null) {
    window.URL.revokeObjectURL(textFile);
    }

    textFile = window.URL.createObjectURL(data);
    console.log(textFile);
    saveAs(data, emailsubject+".eml");
    //window.location = "./JobManagment";
    // var a = document.createElement('a'); //make a link in document
    // var linkText = document.createTextNode('fileLink');
    // a.appendChild(linkText) ;

    // a.href = textFile;

    // a.id = 'fileLink';
    // a.download = emailsubject+".eml"; //'filenameTest.eml' ;
    // a.style.visibility = "hidden";

    // document.body.appendChild(a) ;

    // document.getElementById('fileLink').addEventListener("click",);
  }
  const [getTotalCount, setTotalCount] = useState();
  const cellPrepared = (e) => {
    setTotalCount(e.component.totalCount());
  };
  return (
    <Container maxWidth="md" className="BorderBox">
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={3}>
            <label>
              Job No: &nbsp;
              <TextField
                size="small"
                name="GET_JOB_NO"
                variant="outlined"
                id="GET_JOB_NO"
                value={GET_JOB_NO}
                fullWidth
                onChange={(e) => SET_JOB_NO(e.target.value)}
              />
                {errors.JOBNO && (
              <span className="error-message">{errors.JOBNO}</span>
            )}
            </label>
          </Grid>

          <Grid item xs={12} sm={3}>
         
          </Grid>
          <Grid item xs={12} sm={3}></Grid>
          <Grid item xs={12} sm={3}>
       
          </Grid>
       
        
          <Grid item xs={12} sm={8}>
            <DataGrid
              dataSource={dataSourceOpenJob}
              showBorders={false}
              keyExpr="JOBNO"
              onCellPrepared={cellPrepared}
   
            >
              <Column dataField="JOBNO" caption="JOBNO" width="25%" />
              <Column dataField="ORDER_NO" caption="ORDER_NO" width="25%" />
              <Column dataField="SMF_REFNO" caption="BSE NO." width="25%" />
              <Column dataField="BOOKINGNO" caption="BOOKING NO." width="25%" />
            </DataGrid>
          </Grid>
          <Grid item xs={12} sm={4}>
            {" "}
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>To: </label>
            <TextField
              size="small"
              name="GET_TO_MAIL"
              variant="standard"
              fullWidth
              id="GET_TO_MAIL"
              value={GET_TO_MAIL}
              onChange={(e) => SET_TO_MAIL(e.target.value)}
            />

            {errors.ToMail && (
              <span className="error-message">{errors.ToMail}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>CC: </label>
            <TextField
              size="small"
              name="GET_CC_MAIL"
              variant="standard"
              fullWidth
              id="GET_CC_MAIL"
              value={GET_CC_MAIL}
              onChange={(e) => SET_CC_MAIL(e.target.value)}
            />
          </Grid> 
          {/* <Grid item xs={12} sm={8}>
          <DataGrid
              dataSource={dataSourceCustomerEmail}
              showBorders={false}
              keyExpr="CUSTOMER_CONTACT_ID"
              onSelectionChanged={onSelectionChanged}
              ref={dataGridRef}
              selectedRowKeys={selectedRowKeys}
            >
              <Selection mode="multiple" />
              <Column
                dataField="CUSTOMER_EMAIL"
                caption="SELECT EMAIL"
                width="90%"
              />
              <Column dataField="CONTACT_NAME" caption="NAME" width="30%" />
    
            </DataGrid>
          </Grid>
          <Grid item xs={12} sm={4}>
            {" "}
          </Grid> */}
          <Grid item xs={12} sm={12}>
            <label>Subject: </label>
            <TextField
              size="small"
              name="GET_SUBJECT_MAIL"
              variant="standard"
              fullWidth
              id="GET_SUBJECT_MAIL"
              value={GET_SUBJECT_MAIL}
              onChange={(e) => SET_SUBJECT_MAIL(e.target.value)}
            />
            {errors.SubjectMail && (
              <span className="error-message">{errors.SubjectMail}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <Button1
              disabled={!isButtonDisabled}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
             Open Job
            </Button1>
          </Grid>
          <Grid item xs={12} sm={12}>
          <label>Preview Email: </label><hr/>
          {ReactHtmlParser(GET_BODY_MAIL)}
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
